import React, {useEffect, useState} from 'react'
import {Grid,Paper,Typography,Button} from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {mdiArrowLeft, mdiCar, mdiParking, mdiPhone, mdiViewList} from '@mdi/js'
import Icon from '@mdi/react';
import {Client} from 'client-sdk/src';
import {GetAllDriversRequestBuilder} from 'client-sdk/src/drivers/drivers';
import handleError from '../../utils/handleError';
import { useHistory } from "react-router-dom"
import { GetVehicleEntrancesRequestBuilder } from 'client-sdk/src/entrances/getEntrances';
import { removeEmptyValueObject, flattenObject } from '../../utils/helpers';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '85%',
      padding: '14px',
      boxShadow: 'none !important'
    },
    card: {
      marginTop: "20px",
      paddingBottom: "10px",
      cursor: "pointer"
    },
    cardIcon: {
      margin: "0 20px",
      minWidth: "45px",
      color: "#97A3AB"
    },
    cardItem: {
      marginTop: "12px",
      alignItems: "center",
      padding: "0 10px",
    },
    cardHeader: {
      padding: "10px 30px"
    },
    hr: {
      color: "#BDBDBD61",
      margin: "0"
    },
    pelak: {
      padding: "5px 5px 5px 0",
      border: "1px solid #BDBDBD",
      borderRadius: "2px",
      marginLeft: "20px"
    },
    bottomBox: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: "100%",
      padding: "12px 16px",
      borderTop: '1px solid #000',
      backgroundColor: 'white'
    }
  })
);
const token = localStorage.getItem('token');
function AssignToDriver(props) {
  const history = useHistory();
  const classes = useStyles();
  const [drivers, setDrivers] = useState([]);
  const [selected, setSelected] = useState(0);
  const [selectedEntranceId, setSelectedEntranceId] = useState(0);
  const {id} = props.match.params
  
  const prefferedPageSize = 50;
  const placeHolderPageNumber = 1;

  const whFilters = {
    'vehicleEntranceType.equals': 'ORDER',
      'status.in': ['ENTERED', 'WAITING'],
      'pageNumber': placeHolderPageNumber,
      'size': prefferedPageSize,
      'sort': 'id,desc',
  }

  const passableParams = removeEmptyValueObject(
    flattenObject(whFilters)
  );
  useEffect(() => {
    getDrivers(passableParams)
  }, [])
  
  
  const getDrivers = async (statusFilters: any) => {
    try {
      const makeDriversRequest = new GetVehicleEntrancesRequestBuilder()
      .params(statusFilters)
        .build();
      const client = new Client(token as string);
      const response = await client.execute(makeDriversRequest);
      setDrivers(response.data)
    } catch (error:any) {
      handleError(error.response);
    }
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid container>
          <Paper
            className={classes.titleBar}
          >
            <Grid container xs={10} justifyContent={'center'} alignContent={'center'}>
              <Typography variant="h6" component="h2">
                {'انتخاب راننده'}
              </Typography>

            </Grid>
            <span >
              <Button
                aria-label="details"
                size="medium"
                onClick={() => window.history.back()}
              >
                <Icon path={mdiArrowLeft} size={1} />
              </Button>
            </span>
          </Paper>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: "40px" }}>
        <Typography>لطفا یکی از راننده ها را انتخاب کنید:</Typography>
        {
          drivers.map((driver:any) => (
            <Grid 
              className={classes.card} 
              onClick={() => {setSelected(driver.vehicleId);
            setSelectedEntranceId(driver.id);
            }}
              style={{backgroundColor: selected === driver.vehicleId ? "#C9E5FF" : "#fff"}}>
          <Grid className={classes.cardHeader}>
            <Typography component='h3'>{driver.driverName}</Typography>
            <Typography>{driver.id}</Typography>
          </Grid>
          <hr className={classes.hr}/>
          <Grid container className={classes.cardItem}>
            <span className={classes.cardIcon}>
              <Icon path={mdiPhone} size={1} />
            </span>
            <span>{driver.driverMobileNumber}</span>
          </Grid>
          <Grid container className={classes.cardItem}>
            <span className={classes.cardIcon}>
              <Icon path={mdiViewList} size={1} />
            </span>
            <span>تعارف</span>
          </Grid>
          <Grid container className={classes.cardItem}>
            <span className={classes.cardIcon}>
              <Icon path={mdiParking} size={1} />
            </span>
            <span>پارکینگ ۴</span>
          </Grid>
          <Grid container className={classes.cardItem}>
            <span className={classes.cardIcon}>
              <Icon path={mdiCar} size={1} />
            </span>
            <span>پراید {driver.color}</span>
            <span className={classes.pelak}><span style={{borderLeft: "1px solid #BDBDBD",padding: "5px"}}>{driver.vehiclePlateNumber.substring(7)}</span> {driver.vehiclePlateNumber.substring(3,6)} {driver.vehiclePlateNumber.substring(2,3)} {driver.vehiclePlateNumber.substring(0,2)}</span>
          </Grid>
        </Grid>
          ))
        }
      </Grid>
      <Grid className={classes.bottomBox}>
        <Button
          style={{ marginRight: 'auto' }}
          disabled={!selected}
          size="large"
          data-cy="search"
          autoFocus
          fullWidth
          onClick={() => history.push(`/bundles/${id}/driver/${selected}/entrance/${selectedEntranceId}`)}
          variant="contained"
          color="primary"
        >
          انتخاب راننده
        </Button>
      </Grid>
    </div>
  )
}

export default AssignToDriver
